module.exports = __webpack_public_path__ + "img/american.04fb52ad.svg";